import requireAuthorization from "@/routes/helper/requireAuthorization";
import i18n from "@/i18n";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/power-plans",
        name: "powerPlans",
        component: () => import("@/components/powerPlans/_PowerPlans.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewPowerPlansUI,
            breadcrumbs: {
                icon: "power-plans-icon",
                paths: []
            },
            title: "navbar.powerPlans"
        }
    },
    {
        path: "/power-plan/:powerPlanId/update",
        name: "updatePowerPlan",
        component: () => import("@/components/powerPlans/_PowerPlanForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.GetPowerPlanDetails,
            breadcrumbs: {
                icon: "power-plans-icon",
                paths: [
                    ["/power-plans", i18n.t("powerPlan.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/power-plan/new",
        name: "newPowerPlan",
        component: () => import("@/components/powerPlans/_PowerPlanForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.GetPowerPlanDetails,
            breadcrumbs: {
                icon: "power-plans-icon",
                paths: [
                    ["/power-plans", i18n.t("powerPlan.title")]
                ]
            },
            title: "powerPlan.createTitle"
        },
        props: true
    }
];
